// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as TabCard$OrcaPaymentPage from "./TabCard.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as TestUtils$OrcaPaymentPage from "./Utilities/TestUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./Utilities/RecoilAtomsV2.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "./Context/PaymentTypeContext.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./Payments/PaymentMethodsRecord.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";

function PaymentOptions$TabLoader(props) {
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  var exit = 0;
  if (!(contextPaymentType === "PaymentMethodsManagement" && typeof paymentManagementList !== "object" && paymentManagementList === "SemiLoadedV2")) {
    exit = 2;
  }
  if (exit === 2) {
    if (typeof paymentMethodList === "object") {
      return null;
    }
    if (paymentMethodList !== "SemiLoaded") {
      return null;
    }
    
  }
  return Core__Array.make(props.cardShimmerCount - 1 | 0, "").map(function (param, i) {
              return React.createElement("div", {
                          key: i.toString(),
                          className: "Tab flex flex-col gap-3 animate-pulse cursor-default",
                          style: {
                            cursor: "pointer",
                            minWidth: "5rem",
                            padding: themeObj.spacingUnit,
                            width: "100%",
                            overflowWrap: "hidden"
                          }
                        }, React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
                              children: React.createElement("div", {
                                    className: "w-full h-3 animate-pulse",
                                    style: {
                                      backgroundColor: themeObj.colorPrimary,
                                      opacity: "10%"
                                    }
                                  }),
                              classname: "opacity-50 w-1/3"
                            }), React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
                              children: React.createElement("div", {
                                    className: "w-full h-2 animate-pulse",
                                    style: {
                                      backgroundColor: themeObj.colorPrimary,
                                      opacity: "10%"
                                    }
                                  }),
                              classname: "opacity-50"
                            }));
            });
}

var TabLoader = {
  make: PaymentOptions$TabLoader
};

function PaymentOptions(props) {
  var cardShimmerCount = props.cardShimmerCount;
  var setCardsContainerWidth = props.setCardsContainerWidth;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var customMethodNames = match$1.customMethodNames;
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match$1.layout);
  var payOptionsRef = React.useRef(null);
  var selectRef = React.useRef(null);
  var match$2 = Utils$OrcaPaymentPage.useWindowSize();
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var setSelectedOption = match$3[1];
  var selectedOption = match$3[0];
  var match$4 = React.useState(function () {
        return 0;
      });
  var setMoreIconIndex = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setToggleIconElement = match$5[1];
  var toggleIconElement = match$5[0];
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  React.useEffect((function () {
          var ref = payOptionsRef.current;
          var width = !(ref == null) ? ref.clientWidth : 0;
          setCardsContainerWidth(function (param) {
                return width;
              });
        }), [
        match$2[1],
        match$2[0]
      ]);
  var handleChange = function (ev) {
    var target = ev.target;
    var value = target.value;
    setSelectedOption(function (param) {
          return value;
        });
    CardUtils$OrcaPaymentPage.blurRef(selectRef);
  };
  var cardOptionDetails = PaymentMethodsRecord$OrcaPaymentPage.getPaymentDetails(props.cardOptions, localeString);
  var dropDownOptionsDetails = PaymentMethodsRecord$OrcaPaymentPage.getPaymentDetails(props.dropDownOptions, localeString);
  var allOptions = cardOptionDetails.concat(dropDownOptionsDetails);
  var selectedPaymentOption = Core__Option.getOr(allOptions.find(function (item) {
            return item.paymentMethodName === selectedOption;
          }), PaymentMethodsRecord$OrcaPaymentPage.defaultPaymentFieldsInfo);
  React.useEffect((function () {
          var intervalId = setInterval((function () {
                  if (dropDownOptionsDetails.length > 1) {
                    setMoreIconIndex(function (prev) {
                          return Caml_int32.mod_(prev + 1 | 0, dropDownOptionsDetails.length);
                        });
                    setToggleIconElement(function (param) {
                          return true;
                        });
                    setTimeout((function () {
                            setToggleIconElement(function (param) {
                                  return false;
                                });
                          }), 10);
                    return ;
                  }
                  
                }), 5000);
          return (function () {
                    clearInterval(intervalId);
                  });
        }), [dropDownOptionsDetails]);
  PaymentUtils$OrcaPaymentPage.useEmitPaymentMethodInfo(selectedPaymentOption.paymentMethodName, paymentMethodListValue.payment_methods, props.cardProps, props.expiryProps, props.cvcProps);
  var displayIcon = function (ele) {
    return React.createElement("span", {
                className: "scale-90 animate-slowShow " + (
                  toggleIconElement ? "hidden" : ""
                )
              }, ele);
  };
  var match$6 = layoutClass.paymentMethodsArrangementForTabs;
  var className;
  className = match$6 === "Default" ? "TabHeader flex flex-row overflow-auto no-scrollbar" : "TabHeader grid gap-4 overflow-y-auto";
  var baseStyles_height = "auto";
  var baseStyles_marginBottom = themeObj.spacingGridColumn;
  var baseStyles_padding = "4px";
  var baseStyles_paddingBottom = "7px";
  var baseStyles_columnGap = themeObj.spacingTab;
  var baseStyles = {
    height: baseStyles_height,
    marginBottom: baseStyles_marginBottom,
    padding: baseStyles_padding,
    paddingBottom: baseStyles_paddingBottom,
    columnGap: baseStyles_columnGap
  };
  var match$7 = layoutClass.paymentMethodsArrangementForTabs;
  var style;
  if (match$7 === "Default") {
    style = baseStyles;
  } else {
    var newrecord = Caml_obj.obj_dup(baseStyles);
    newrecord.gridTemplateColumns = "repeat(" + cardShimmerCount.toString() + ", minmax(0, 1fr))";
    newrecord.gridAutoRows = "1fr";
    style = newrecord;
  }
  var paymentFieldsInfo = dropDownOptionsDetails[match$4[0]];
  var tmp;
  if (paymentFieldsInfo !== undefined) {
    var ele = paymentFieldsInfo.miniIcon;
    if (ele !== undefined) {
      tmp = displayIcon(Caml_option.valFromOption(ele));
    } else {
      var ele$1 = paymentFieldsInfo.icon;
      tmp = ele$1 !== undefined ? displayIcon(Caml_option.valFromOption(ele$1)) : null;
    }
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "w-full"
            }, React.createElement("div", {
                  ref: Caml_option.some(payOptionsRef),
                  className: className,
                  "data-testid": TestUtils$OrcaPaymentPage.paymentMethodListTestId,
                  style: style
                }, cardOptionDetails.map(function (payOption, i) {
                      var isActive = payOption.paymentMethodName === selectedOption;
                      return JsxPPXReactSupportU.createElementWithKey(i.toString(), TabCard$OrcaPaymentPage.make, {
                                  paymentOption: payOption,
                                  isActive: isActive
                                });
                    }), React.createElement(PaymentOptions$TabLoader, {
                      cardShimmerCount: cardShimmerCount
                    }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                      condition: dropDownOptionsDetails.length > 0,
                      children: React.createElement("div", {
                            className: "flex relative h-auto justify-center"
                          }, React.createElement("div", {
                                className: "flex flex-col items-center absolute mt-3 pointer-events-none gap-y-1.5"
                              }, tmp, React.createElement(Icon$OrcaPaymentPage.make, {
                                    name: "arrow-down",
                                    size: 10
                                  })), React.createElement("select", {
                                ref: Caml_option.some(selectRef),
                                className: "TabMore place-items-start outline-none",
                                "data-testid": TestUtils$OrcaPaymentPage.paymentMethodDropDownTestId,
                                style: {
                                  background: themeObj.colorBackground,
                                  color: "transparent",
                                  cursor: "pointer",
                                  height: "inherit",
                                  paddingLeft: themeObj.spacingUnit,
                                  width: "40px",
                                  borderRadius: themeObj.borderRadius,
                                  appearance: "none"
                                },
                                disabled: match$1.readOnly,
                                value: selectedPaymentOption.paymentMethodName,
                                onChange: handleChange
                              }, React.createElement("option", {
                                    disabled: true,
                                    value: selectedPaymentOption.paymentMethodName
                                  }, PaymentUtils$OrcaPaymentPage.getDisplayNameAndIcon(customMethodNames, selectedPaymentOption.paymentMethodName, selectedPaymentOption.displayName, selectedPaymentOption.icon)[0]), dropDownOptionsDetails.map(function (item, i) {
                                    return React.createElement("option", {
                                                key: i.toString(),
                                                style: {
                                                  color: themeObj.colorPrimary
                                                },
                                                value: item.paymentMethodName
                                              }, PaymentUtils$OrcaPaymentPage.getDisplayNameAndIcon(customMethodNames, item.paymentMethodName, item.displayName, item.icon)[0]);
                                  })))
                    })), props.checkoutEle);
}

var make = PaymentOptions;

export {
  TabLoader ,
  make ,
}
/* react Not a pure module */
